import styled from "styled-components";

export const TopicStyle = styled.div`
  color: #1a1a1a;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.3px;
  margin: 0 !important;
  padding-top: 20px;
`;

export const DescStyle = styled.div`
  color: #707070;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.21px;
  padding-top: 8px;
`;
